// extracted by mini-css-extract-plugin
module.exports = {"link":"mod-_4N6qCIq","active":"mod-1fPObHoV"};